module.exports = __webpack_public_path__ + "static/img/bcg-img.38c5723e.png";